var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M22,0H2C1.447,0,1,0.448,1,1v22c0,0.552,0.447,1,1,1h20c0.553,0,1-0.448,1-1V1C23,0.448,22.553,0,22,0z M20,21H4V3h3v3h3c0-1.105,0.895-2,2-2s2,0.895,2,2h3V3h3V21z"}}),_c('path',{attrs:{"d":"M11,17c-0.256,0-0.512-0.098-0.707-0.293L7.586,14L9,12.586l2,2l4-4L16.414,12l-4.707,4.707 C11.512,16.902,11.256,17,11,17z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }